<svg class="svg_icon--tick" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
  <defs>
    <style>.svg_icon--tick .icon{fill:currentColor;}</style>
  </defs>
  <title>✓</title>
  <g>
    <path class="icon"
          d="M32.64,92.85a8.24,8.24,0,0,1-1.22-.08,8.87,8.87,0,0,1-5.92-3.56l-18-24.88a9,9,0,0,1-.13-10.56,8.84,8.84,0,0,1,14.27,0L32.15,68.35l2-2.93C49.81,42,65.39,23.9,80.44,11.77a9.33,9.33,0,0,1,5.82-2A8.67,8.67,0,0,1,95,19.21a8.88,8.88,0,0,1-3.26,6.1c-16.47,13.2-33.82,34.51-51.6,63.36A8.79,8.79,0,0,1,33,92.85Z"/>
  </g>

</svg>